import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CoordinatePoint, CoordinatePointModel } from 'src/app/models/coordinate-point';
import { CoordinatePointsService } from 'src/app/services/coordinate-points.service';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import * as fileSaver from 'file-saver';
@Component({
  selector: 'app-coord-point-duplication-check',
  templateUrl: './coord-point-duplication-check.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class CoordPointDuplicationCheckComponent implements OnInit {

  @Input()
  duplicates:CoordinatePointModel[]

  constructor(public bsModalRef: BsModalService,
    public coordinatePointService: CoordinatePointsService,
    public endpointService: EndpointsService,
    private modalControlService: ModalControlService,
    public http: HttpClient
    ) { }

  ngOnInit(): void {
  }

  public static showDuplicates(coord_points: CoordinatePointModel[],modalService:BsModalService, modalControl:ModalControlService){
    let duplicates: CoordinatePointModel[] = [];
  const processedIds = new Set<String>();

  if (coord_points != null) {
    for (let i = 0; i < coord_points.length-1; i++) {
      if (processedIds.has(coord_points[i].coordpointid)) {
        continue;
      }
      
      processedIds.add(coord_points[i].coordpointid);
      let duplicateDetected = false;
      
      for (let j = i + 1; j < coord_points.length; j++) {
        if (CoordinatePointModel.duplicationCheckCondition(coord_points[i], coord_points[j])) {
          duplicates.push(coord_points[j]);
          duplicateDetected = true;
        }
      }
      
      if (duplicateDetected) {
        duplicates.push(coord_points[i]);
      }
    }
  }
  
  if(duplicates.length>0){
    let bsRef: BsModalRef = modalService.show(CoordPointDuplicationCheckComponent);
    bsRef.content.duplicates = duplicates.sort((coord1,coord2)=> coord1.coordpointid > coord2.coordpointid? 1 : -1 );
    return;
  }
  modalControl.showMesssageModal("Duplicate Check Done", "No duplicates were found.","Ok");
  }


  exportCoordinatePointsToCsv(){
    let coordinatePointPayloads: CoordinatePoint[] = [];
    this.duplicates.forEach((coordPoint) => coordinatePointPayloads.push(this.coordinatePointService.getCoordinatePointPayload(coordPoint)));
    this.http.post(this.endpointService.endPointDownloadCSVCoordPoints,
      coordinatePointPayloads,
      this.endpointService.fileHttpOptions
    ).subscribe((blob:Blob) => {
      fileSaver.saveAs(blob, "coordPoints.csv");
    },
    (error) => this.modalControlService.showMesssageModal("error","Error generating csv file")
    )
  }

}
